import { useTranslation } from "react-i18next";

import { useAnalytics } from "@/components/analytics/useAnalytics";
import { useDialogState } from "@/components/dialogs/useDialogState";
import { JobRequest } from "@/data/job-requests/types/JobRequest";
import { formatMultipleLocations } from "@/data/locations";

export const useApplyModalState = (jobRequest: JobRequest) => {
  const { t } = useTranslation("session");

  const { sendEvent } = useAnalytics();

  return useDialogState({
    afterShow: () => {
      sendEvent({
        type: "apply_job_begin",
        id: jobRequest.id,
        name: jobRequest.title!,
        location: formatMultipleLocations(t, jobRequest.locations, jobRequest.locations?.length),
      });
    },
    afterHide: () => {
      sendEvent({
        type: "apply_job_end",
        id: jobRequest.id,
        name: jobRequest.title!,
        location: formatMultipleLocations(t, jobRequest.locations, jobRequest.locations?.length),
      });
    },
  });
};
